import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { Layout } from 'components/Layout';
import MapComponent from 'components/MapComponent';
import { WorldFC } from 'components/World';
import { useInitPage } from 'components/World/hooks/useInitPage';
import { ROUTE_MAP } from 'consts/url';
import {
  Redirect,
  useHistory,
} from 'react-router-dom/cjs/react-router-dom.min';
import NotFound from './NotFound';
import configs from './configs';
import { cleanLoadTexture } from './utils/textureHelper';
// import GalleryMenu from 'components/GalleryMenu';
import { SCENES_MAP } from 'consts/building';
import { useEffect } from 'react';

window.defaultTexture = null;
cleanLoadTexture(configs.baseUrl + '/assets/images/white-square.png').then(
  (texture) => {
    window.defaultTexture = texture;
  }
);

function AppRoutes() {
  return (
    <BrowserRouter basename={configs.baseUrl}>
      <Layout>
        <Switch>
          <Route
            exact
            path="/not-found"
            render={(props) => <NotFound {...props} />}
          />

          <Route
            index
            path={`/${ROUTE_MAP.map.id}`}
            render={(props) => <MapComponent {...props} />}
          />

          <Route
            index
            path={`/etown-central/:slug*`}
            render={(props) => (
              <MapComponent
                {...props}
                imgUrl={'/assets/images/etown-central.jpg'}
              />
            )}
          />

          <Route
            path="/font-view"
            render={(props) => <Redirect to={`/front-view`} />}
          />

          <Route
            path={`/:slug*`}
            render={(props) => (
              <PageContainer location={props.location}>
                <WorldFC />
              </PageContainer>
            )}
          />

          <Route
            path="/"
            render={(props) => <Redirect to={`/${ROUTE_MAP.map.id}`} />}
          />

          {/* <Route
            exact
            index
            path={`/gallery`}
            render={(props) => <GalleryMenu {...props} />}
          /> */}

          <Route
            path="*"
            render={(props) => <Redirect to={`/${ROUTE_MAP.map.id}`} />}
          />
        </Switch>
      </Layout>
    </BrowserRouter>
  );
}

// Danh sách các route đặc biệt không cần check trong APARTMENT_MAP
const EXCLUDED_ROUTES = [
  `/${ROUTE_MAP.map.id}`,
  // '/gallery',
  '/amenities',
  '/not-found',
  '/etown-central',
];

// Kiểm tra xem pathname có phải là route đặc biệt hợp lệ không (exact match hoặc sub-path)
const isValidSpecialRoute = (pathname, route) => {
  // Exact match
  if (pathname === route) {
    return true;
  }
  // Sub-path hợp lệ (phải có slash sau route, không phải ký tự khác)
  // Ví dụ: /tien-ich/something hợp lệ, nhưng /tien-ich121212 không hợp lệ
  const routeWithSlash = route + '/';
  if (pathname.startsWith(routeWithSlash)) {
    return true;
  }
  return false;
};

// Kiểm tra xem pathname có trong SCENES_MAP (bao gồm APARTMENT_MAP và AMENITIES_MAP) không
const isValidPath = (pathname) => {
  // Loại bỏ trailing slash và normalize pathname
  const normalizedPath = pathname.replace(/\/$/, '') || '/';

  // Kiểm tra các route đặc biệt với exact match hoặc sub-path hợp lệ
  if (
    EXCLUDED_ROUTES.some((route) => isValidSpecialRoute(normalizedPath, route))
  ) {
    return true;
  }

  // Kiểm tra xem pathname có trong danh sách URL của SCENES_MAP không
  const validPaths = Object.values(SCENES_MAP).map((item) => item.url);
  const isValid = validPaths.some((path) => {
    const normalizedMapPath = path.replace(/\/$/, '') || '/';
    return (
      normalizedPath === normalizedMapPath ||
      normalizedPath.startsWith(normalizedMapPath + '/')
    );
  });

  return isValid;
};

export const PageContainer = ({ children, location }) => {
  const history = useHistory();
  useInitPage(location.pathname);

  useEffect(() => {
    const pathname = location.pathname;

    // Bỏ qua root path
    if (pathname === '/') {
      return;
    }

    // Bỏ qua các route đặc biệt (gallery, tien-ich, map, not-found, etown-central)
    // Chỉ match exact hoặc sub-path hợp lệ (có slash sau route)
    const normalizedPathname = pathname.replace(/\/$/, '') || '/';
    if (
      // isValidSpecialRoute(normalizedPathname, '/gallery') ||
      isValidSpecialRoute(normalizedPathname, '/amenities') ||
      normalizedPathname === `/${ROUTE_MAP.map.id}` ||
      normalizedPathname === '/not-found' ||
      normalizedPathname.startsWith('/etown-central/') ||
      normalizedPathname === '/etown-central'
    ) {
      return;
    }

    // Kiểm tra xem pathname có hợp lệ không
    if (!isValidPath(pathname)) {
      // Redirect về /map nếu path không hợp lệ
      history.replace(`/${ROUTE_MAP.map.id}`);
    }
  }, [location.pathname, history]);

  if (location.pathname === `/`) {
    return <Redirect to={`/${ROUTE_MAP.map.id}`} />;
  }

  return children;
};

export default AppRoutes;
